import React from 'react';

import { ICONS } from '@/constants/icons';
import i18n from '@/i18n';
import Empty from '@/shared/ui/Empty';

/**
 * Primo passo di un import: campi specifici del dominio + selettore file.
 *
 * Estratto da `ImportMappingModal` perché la stessa coppia file/mapping serve
 * anche agli import con un'anteprima propria (es. i viaggi giornalieri, che
 * devono risolvere i passeggeri riga per riga): senza estrazione l'unico modo
 * di riusarla sarebbe duplicarla.
 */
export default function ImportFileStep({ extraFields = null, onFile, disabled = false }) {
  return (
    <>
      {extraFields}
      <div className="field">
        <label htmlFor="import-file">
          {i18n.t('import_seleziona_file', {
            defaultValue: 'Seleziona un file JSON, Excel o CSV',
          })}
        </label>
        <input
          id="import-file"
          type="file"
          accept=".json,.xlsx,.xls,.csv"
          onChange={onFile}
          disabled={disabled}
        />
        <Empty
          icon={ICONS.import}
          title={i18n.t('import_nessun_file', { defaultValue: 'Nessun file selezionato' })}
        />
      </div>
    </>
  );
}
